import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";


const EmployeeDetailsReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/employeeMis");
  };

  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: getEmployeeDetails } = useHttp();

  const fillEmployeeData = () => {
    var url = `/api/employeeDetailReport/?orgId=${localStorage.getItem(
      "orgId"
    )}`;

    getEmployeeDetails(
      {
        url: url,
      },
      (res) => {
     
        if (res) {
          const transformedData = res?.map((item, i) => ({
            srNo: i + 1,
            employeeName: item.employeeName || "",
            employeeCode: item.employeeCode || "",
            birthDate: item.birthDate || "",
            dateofJoining: item.dateofJoining || "",
            departmentName: item.departmentName || "",
            designationName: item.designationName || "",
            gender: item.gender || "",
            whatsappNo: item.whatsappNo || "",
            contactNo: item.contactNo || "",
            emailId: item.emailId || "",
            employmentType: item.employmentType || "",
            workContactNo: item.workContactNo || "",
            workEmailId: item.workEmailId || "",
            reportingManager: item.reportingEmployee || "",
            permanentLandmark:
              item.address?.find((addr) => addr.addressType === "Permanent")
                ?.landmark || "",
            permanentLga:
              item.address?.find((addr) => addr.addressType === "Permanent")
                ?.lga || "",
            permanentCity:
              item.address?.find((addr) => addr.addressType === "Permanent")
                ?.city || "",
            permanentState:
              item.address?.find((addr) => addr.addressType === "Permanent")
                ?.state || "",
            permanentCountry:
              item.address?.find((addr) => addr.addressType === "Permanent")
                ?.country || "",
            permanentZipcode:
              item.address?.find((addr) => addr.addressType === "Permanent")
                ?.zipcode || "",
            residentialLandmark:
              item.address?.find((addr) => addr.addressType === "Residential")
                ?.landmark || "",
            residentialLga:
              item.address?.find((addr) => addr.addressType === "Residential")
                ?.lga || "",
            residentialCity:
              item.address?.find((addr) => addr.addressType === "Residential")
                ?.city || "",
            residentialState:
              item.address?.find((addr) => addr.addressType === "Residential")
                ?.state || "",
            residentialCountry:
              item.address?.find((addr) => addr.addressType === "Residential")
                ?.country || "",
            residentialZipcode:
              item.address?.find((addr) => addr.addressType === "Residential")
                ?.zipcode || "",
          }));

          console.log(transformedData);

          setData(transformedData);
        }
      }
    );
  };

  useEffect(() => {
    fillEmployeeData();
  }, [getEmployeeDetails]);

  const fieldsToExport = [
    "srNo",
    "employeeName",
    "employeeCode",
    "birthDate",
    "dateofJoining",
    "departmentName",
    "designationName",
    "gender",
    "whatsappNo",
    "contactNo",
    "emailId",
    "employmentType",
    "workContactNo",
    "workEmailId",
    "reportingManager",
    "permanentLandmark",
    "permanentLga",
    "permanentCity",
    "permanentState",
    "permanentCountry",
    "permanentZipcode",
    "residentialLandmark",
    "residentialLga",
    "residentialCity",
    "residentialState",
    "residentialCountry",
    "residentialZipcode",
  ];

  const customHeaders = [
    "Sr No",
    "Employee Name",
    "Employee Code",
    "Birth Date",
    "Joining Date",
    "Department Name",
    "Designation Name",
    "Gender",
    "Whatsapp No",
    "Contact No",
    "Email Id",
    "Employment Type",
    "Work Contact No",
    "Work Email",
    "Reporting Manager",
    "Permanent Address",
    "Permanent LGA",
    "Permanent City",
    "Permanent State",
    "Permanent Country",
    "Permanent Zip Code",
    "Residential Address",
    "Residential LGA",
    "Residential City",
    "Residential State",
    "Residential Country",
    "Residential Zip Code",
  ];

  const handleExportExcel = () => {
    const filename = "EmployeeDetailReport.xlsx";
    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Employee Details Reports</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Sr No</th>
                          <th>Employee Name</th>
                          <th>Employee Code</th>
                          <th>Birth Date</th>
                          <th>Joining Date</th>
                          <th>Department Name</th>
                          <th>Designation Name</th>
                          <th>Gender</th>
                          <th>Whatsapp No</th>
                          <th>Contact No</th>
                          <th>Email Id</th>
                          <th>Employment Type</th>
                          <th>Work Contact No</th>
                          <th>Work Email</th>
                          <th>Reporting Manager</th>
                          <th>Permanent Address</th>
                          <th>Permanent LGA</th>
                          <th>Permanent City</th>
                          <th>Permanent State</th>
                          <th>Permanent Country</th>
                          <th>Permanent Zip Code</th>
                          <th>Residential Address</th>
                          <th>Residential LGA</th>
                          <th>Residential City</th>
                          <th>Residential State</th>
                          <th>Residential Country</th>
                          <th>Residential Zip Code</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              <td>{itm.srNo}</td>
                              <td>{itm.employeeName}</td>
                              <td>{itm.employeeCode}</td>
                              <td>{itm.birthDate}</td>
                              <td>{itm.dateofJoining}</td>
                              <td>{itm.departmentName}</td>
                              <td>{itm.designationName}</td>
                              <td>{itm.gender}</td>
                              <td>{itm.whatsappNo}</td>
                              <td>{itm.contactNo}</td>
                              <td>{itm.emailId}</td>
                              <td>{itm.employmentType}</td>
                              <td>{itm.workContactNo}</td>
                              <td>{itm.workEmailId}</td>
                              <td>{itm.reportingManager}</td>

                              <td>{itm.permanentLandmark}</td>
                              <td>{itm.permanentLga}</td>
                              <td>{itm.permanentCity}</td>
                              <td>{itm.permanentState}</td>
                              <td>{itm.permanentCountry}</td>
                              <td>{itm.permanentZipcode}</td>
                              <td>{itm.residentialLandmark}</td>
                              <td>{itm.residentialLga}</td>
                              <td>{itm.residentialCity}</td>
                              <td>{itm.residentialState}</td>
                              <td>{itm.residentialCountry}</td>
                              <td>{itm.residentialZipcode}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EmployeeDetailsReport;
